module.exports = __webpack_public_path__ + "static/10invgde-f43d3765113bbc5f4ac0445922b755a3.gif";